import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { CustomerEnquiryForm } from '../../../../models/home/customer-enquiry-form';
import { LoginEntityService } from '../../../../services/entity-services/login-entity.service';
import { EnquiryEntityService } from '../../../../services/enquiry-services/enquiry-entity.service';
import { Log, IShortLogger } from '../../../../services/logger.service';


@Component({
  selector: 'app-customer-enquiry-form',
  templateUrl: './customer-enquiry-form.component.html',
  styleUrl: './customer-enquiry-form.component.css'
})
export class CustomerEnquiryFormComponent {
  private readonly logger: IShortLogger<CustomerEnquiryFormComponent> = Log.create(CustomerEnquiryFormComponent);
  showPreview = false;
  formDataToSubmit: any;

  redirectTimer: any;
  showPopup = false;
  countdown = 3;
  enquiryForm: FormGroup;

  constructor(
    private router: Router,
    private loginEntityService: LoginEntityService,
    private enquiryEntityService: EnquiryEntityService,
    private fb: FormBuilder) {
    this.enquiryForm = this.fb.group({
      customerName: ['', Validators.required],
      contactPerson: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]],
      mobileNumber: ['', []],
      subject: ['', Validators.required],
      enquiryDetails: ['', Validators.required]
    });
  }


  onSubmit() {
    if (this.enquiryForm.valid) {
      this.formDataToSubmit = this.enquiryForm.value;
      this.showPreview = true; // Show preview popup
    }
  }


  async confirmSubmit() {
    const formData = this.formDataToSubmit;

    const newCustomerEnquiry = new CustomerEnquiryForm();
    newCustomerEnquiry.name = formData.customerName;
    newCustomerEnquiry.contactPerson = formData.contactPerson;
    newCustomerEnquiry.email = formData.email;
    newCustomerEnquiry.mobileNumber = formData.mobileNumber;
    newCustomerEnquiry.subject = formData.subject;
    newCustomerEnquiry.enquiryDetails = formData.enquiryDetails;
    // newCustomerEnquiry.enquiryStatus = 'draft';
    newCustomerEnquiry.createdDate = new Date();
    newCustomerEnquiry.firstAssignedDate;
    newCustomerEnquiry.lastAssignedDate;
    newCustomerEnquiry.convStartDate;
    newCustomerEnquiry.convEndDate;
    newCustomerEnquiry.assignedHistory = [];
    newCustomerEnquiry.stateHistory = [{'status': 'draft', 'timeStamp': new Date()}];
    newCustomerEnquiry.conversations = [];

    const created = await this.enquiryEntityService.createCustomerEnquiry(newCustomerEnquiry);

    this.logger.i('Created Customer Enquiry Record:', created);

    this.showPreview = false;
    this.onReset();
    this.showSuccessPopup();
  }

  cancelPreview() {
    this.showPreview = false;
  }

  showSuccessPopup() {
    this.showPopup = true;
    this.countdown = 3;
    this.startRedirectTimer();
  }

  startRedirectTimer() {
    this.redirectTimer = setInterval(() => {
      this.countdown--;
      if (this.countdown <= 0) {
        this.redirectToLogin();
      }
    }, 1000);
  }

  stopRedirect() {
    if (this.redirectTimer) {
      clearInterval(this.redirectTimer);
      this.redirectTimer = null;
    }
    this.showPopup = false;
    this.countdown = 3;
  }

  redirectToLogin() {
    if (this.redirectTimer) {
      clearInterval(this.redirectTimer);
      this.redirectTimer = null;
    }
    this.showPopup = false;
    this.router.navigate(['/login']);
  }


  onReset() {
    this.enquiryForm.reset();
  }
}
